export default (entities) => ({
  updateOrganization(data) {
    return entities.Organization.update(data);
  },
});
